<div
  class="side-sheet fixed lg:w-9/12 sm:w-11/12 md:w-[93%] md:ml-[3.8%] lg:ml-20 z-30 sm:ml-[4%] left-[-100%] sm:h-96 overflow-y-auto md:h-unset sm:py-8 sm:pl-[2.997rem] sm:pr-[2.997rem] md:pl-[1.25rem] md:pr-[2.997rem] bg-[#3A3F45] lg:py-[1.9975rem] lg:px-[2.9969rem] rounded-[1.24875rem]"
  [class.open]="isOpen()"
>
  <div class="w-full h-full flex flex-col">
    <!-- Your side sheet content goes here -->
    <div class="flex flex-row justify-between items-center">
      <div>
        <span class="text-white ml-1 font-semibold h-8 leading-[100%]"
          >Weather Forecast</span
        >
      </div>
      <div>
        <app-close-icon class="p-2 text-white cursor-default" (appClickableDirective)="toggle()" />
      </div>
    </div>
    <div
      class="whitespace-nowrap flex-grow overflow-x-auto sm:flex md:inline-block w-full sm:justify-between sm:flex-col py-2 pb-3 mr-2"
    >
      @for (item of weatherData(); track $index) {
        <div
          class="sm:flex md:inline-block md:w-32 h-full max-h-full justify-center sm:w-full items-center px-2"
        >
    
        <div
          class="flex sm:flex-row md:flex-col mt-4 sm:justify-between w-full md:justify-content:unset sm:items-center md:items-stretch"
        >
          <div
            class="time-content md:text-center sm:w-20 lg:w-unset h-[1.1237 rem]"
          >
            <span
              class="text-white font-normal sm:text-[0.749rem] tracking-wider leading-[100%] font-inter"
              >{{ item.dt_txt | date: "EEE,dd HH:mm" }}</span
            >
          </div>
          @if (item?.iconUrl) {
            <div
              class="flex flex-row items-center justify-center md:mt-3 sm:text-xs sm:w-12 md:w-unset leading-[100%]"
            >
              <img [src]="item.iconUrl" alt="Weather" class="w-8 h-8" />
            </div>
          }
          <div
            class="flex flex-row space-x-4 text-center text-white md:mt-4 sm:w-24 lg:w-unset"
          >
            <div class="md:w-full text-center">
              <span class="sm:text-xs leading-[100%]">Max</span>
            </div>
            <div class="md:w-full text-center">
              <span class="sm:text-[0.99875 rem] leading-[100%]"
                >{{ item.main.temp_max }} °C</span
              >
            </div>
          </div>
          <div
            class="flex flex-row space-x-4 text-white text-center sm:w-24 lg:w-unset md:mt-4"
          >
            <div class="md:w-full text-center">
              <span class="sm:text-xs leading-[100%]">Min</span>
            </div>
            <div class="md:w-full text-center">
              <span class="sm:text-[0.99875 rem] leading-[100%]"
                >{{ item.main.temp_min }} °C</span
              >
            </div>
          </div>
        </div>
        </div>
      }
    </div>
  </div>
</div>
<!-- Overlay -->
@if (isOpen()) {
  <div class="overlay" (appClickableDirective)="toggle()"></div>
}
